import React, { Component } from "react";
import { injectIntl, FormattedMessage } from "react-intl";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { Table } from "antd";
import { COOKIE_MFA } from "../../utils/index";
import { getClients, getWorkClients } from "../../actions/ClientsAction";
import { getNotifications, setPid } from "../../actions/NotificationAction";
import { existsConfirmAssets } from "../../actions/AssetsConfirmAction";
import { forceColor } from "../../actions/AuthAction";
import {
  getClientById,
  getBreadCrumbsByClient,
  getUserClientRole,
  setPidExistsConfirmAssets,
  cleanClientData
} from "../../actions/ClientAction";
import { getFilterUsers } from "../../actions/UsersAction";
import { getDefaultPermissions } from "../../actions/GroupAction";
import {
  // NOTIFICATION_INTERVAL_TIME,
  sendNotification,
  PROD_CLIENT_IAB_COLOMBIA
} from "../../utils/index";
import { Spin } from "antd";
import Cookies from "universal-cookie";
import "./clients.css";
import CloseWindowModal from "../sign-in-modal/CloseWindowModal";
import BunkeyAPI from "../../api/BunkeyAPI";
import PendingPaymentModal from "./PendingPaymentModal";
import { logout } from "../../actions/AuthAction";
import { isEnterpriseUser } from "../../utils/plan-utils";

const ImageCell = image => (
  <img style={{ width: 50 }} src={image.image} alt="logo" />
);

const columns = [
  {
    title: "Logo",
    dataIndex: "logo",
    render: image => <ImageCell image={image} />
  },
  {
    title: <FormattedMessage id="clients_client" />,
    dataIndex: "client"
  },
  {
    title: <FormattedMessage id="clients_dni" />,
    dataIndex: "dni"
  },
  {
    title: <FormattedMessage id="clients_ContactData" />,
    dataIndex: "agent"
  },
  {
    title: <FormattedMessage id="clients_status" />,
    dataIndex: "status"
  }
];

export class Clients extends Component {
  constructor(props) {
    super(props);

    this.state = {
      data: null,
      limit: 10,
      count: 1,
      isLoading: false,
      activePage: 1,
      showCloseWindowModal: false,
      loadingPayment: false,
      showPendingPaymentModal: false,
      pendingPaymentModalClosable: true,
      paymentUrl: "",
      paymentMessage: "",
      closeLabel: ""
    };
  }

  componentDidMount() {
    this.props.cleanClientData();
    this.handleGetData();

    // comentado mientras se mejora performance
    // this.props.getFilterUsers();
  }

  componentDidUpdate(prevProps) {
    const {
      data,
      headers,
      isFetching,
      isDone,
      clienteSelected,
      error,
      intl,
      user
    } = this.props;
    const { showPendingPaymentModal, loadingPayment } = this.state;
    if (!isFetching && error && prevProps.error !== error) {
      this.setState(
        {
          data: null
        },
        () => {
          sendNotification(
            "error",
            intl,
            intl.formatMessage({ id: "error_message" })
          );
        }
      );
    } else if (
      !isFetching &&
      data &&
      data.length > 0 &&
      prevProps.data !== data
    ) {
      this.setState({
        data,
        limit: parseInt(headers["x-pagination-limit"]),
        count: parseInt(headers["x-pagination-total-count"])
      });
    }

    if (isDone) {
      let isMFA = false;
      const cookies = new Cookies();
      const cookieMfa = cookies.get(COOKIE_MFA);
      if (clienteSelected && clienteSelected.modules) {
        clienteSelected.modules.forEach(item => {
          if (item.name === "MFA" && item.activate === true) {
            isMFA = true;
          }
        });
      }
      if (isMFA) {
        if (
          cookieMfa &&
          cookieMfa.length > 0 &&
          cookieMfa.includes(clienteSelected._id)
        ) {
          this.props.history.push("/home");
        } else {
          this.props.history.push("/security-mfa");
        }
      } else if (clienteSelected && clienteSelected._id) {
        if (
          clienteSelected.paymentStatus ||
          user.role === "admin" ||
          isEnterpriseUser(clienteSelected)
        ) {
          this.props.history.push("/home");
        } else if (!showPendingPaymentModal) {
          if (loadingPayment) return;
          this.setState({
            loadingPayment: true
          });
          BunkeyAPI({
            url: `/clients/${clienteSelected._id || 1}/plangolocal`,
            method: "POST",
            data: {
              name: clienteSelected.name,
              amount: 24
            }
          })
            .then(resp => {
              this.setState({
                loadingPayment: false
              });
              const { url } = resp.data;
              if (user.workClients.length === 1) {
                this.setState({
                  paymentMessage:
                    user.clientRole === "admin"
                      ? intl.formatMessage({ id: "payment-message-1" })
                      : intl.formatMessage({ id: "payment-message-2" }),
                  paymentUrl: url,
                  pendingPaymentModalClosable: false,
                  showPendingPaymentModal: true,
                  closeLabel: "Cerrar sesión"
                });
              } else {
                this.setState({
                  paymentMessage:
                    user.clientRole === "admin"
                      ? intl.formatMessage({ id: "payment-message-3" })
                      : intl.formatMessage({ id: "payment-message-4" }),
                  paymentUrl: url,
                  pendingPaymentModalClosable: true,
                  showPendingPaymentModal: true,
                  closeLabel: "Cerrar"
                });
              }
              // window.open(url, "_blank", "noreferrer");
              // this.handleShowCloseWindowModal();
            })
            .catch(err => {
              sendNotification(
                "success",
                intl,
                `Ocurrió un error al generar el pago`
              );
            });
        }
      }
    }
    if (!clienteSelected && prevProps.clienteSelected) {
      this.setState({
        showPendingPaymentModal: false,
        isLoading: false
      });
    }
  }

  handleShowCloseWindowModal = () => {
    this.setState({
      showCloseWindowModal: true
    });
  };

  handleGetData = () => {
    const { activePage } = this.state;
    const { user } = this.props;

    if (user.role === "admin") {
      this.props.getClients(activePage);
    } else {
      if (user.workClients.length === 1) {
        this.handleSetWorkClient(user.workClients[0]);
      } else {
        this.props.getWorkClients(user.workClients);
      }
    }
  };

  handleHidePendingPaymentModal = () => {
    const { pendingPaymentModalClosable } = this.state;
    if (!pendingPaymentModalClosable) {
      this.props.logout();
      return;
    }
    this.props.cleanClientData();
  };

  handleSetWorkClient = id => {
    this.setState(
      {
        isLoading: true
      },
      () => {
        // 20201007 IAB COLOMBIA
        // SI ES IAB COLOMBIA SE ASIGNA COLOR FIJO
        if (id === PROD_CLIENT_IAB_COLOMBIA) {
          this.props.forceColor("#C62918");
        }

        this.props
          .getClientById(id)
          .then(() => {
            this.props.getDefaultPermissions();
            return this.props.getUserClientRole(id);
          })
          .then(() => {
            this.props.getBreadCrumbsByClient(id);
          })
          .catch(err => {});
      }
    );
  };

  onChangePage = page => {
    this.setState(
      {
        activePage: page
      },
      () => {
        this.handleGetData();
      }
    );
  };

  render() {
    const {
      data,
      limit,
      count,
      activePage,
      isLoading,
      showCloseWindowModal,
      showPendingPaymentModal,
      paymentMessage,
      pendingPaymentModalClosable,
      paymentUrl,
      closeLabel
    } = this.state;
    const { width, isFetching, user, isDone, clienteSelected } = this.props;

    const isMobileTable = width ? (width <= 768 ? true : false) : false;
    let dataTable = null;
    if (data && data.length > 0) {
      dataTable =
        data && data.length > 0
          ? data.map(r => {
              return {
                logo: r.acountSetting.logo,
                client: r.name,
                dni: r.dni,
                agent: r.email,
                status: r.status ? "Activo" : "Pendiente",
                _id: r._id
              };
            })
          : null;
    }

    return (
      <React.Fragment>
        {!isDone && clienteSelected && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              height: "100vh",
              width: "100%",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              backgroundColor: "white",
              zIndex: 10
            }}
          >
            <Spin size="large" />
          </div>
        )}
        {!isFetching && !isMobileTable && (
          <Table
            bordered
            loading={isFetching || isLoading}
            className="selector-client-table"
            onRow={(record, rowIndex) => ({
              onClick: event => {
                this.handleSetWorkClient(record._id);
              },
              onMouseEnter: event => {
                document.body.style.cursor = "pointer";
              },
              onMouseLeave: event => {
                document.body.style.cursor = "default";
              }
            })}
            rowKey="_id"
            columns={columns}
            dataSource={dataTable}
            pagination={{
              current: activePage,
              pageSize: limit,
              total: count,
              onChange: this.onChangePage
            }}
          />
        )}

        {!isFetching && isMobileTable && (
          <Table
            bordered
            loading={isFetching || isLoading}
            className="selector-client-responsive"
            onRow={(record, rowIndex) => ({
              onClick: event => {
                this.handleSetWorkClient(record._id);
              },
              onMouseEnter: event => {
                document.body.style.cursor = "pointer";
              },
              onMouseLeave: event => {
                document.body.style.cursor = "default";
              }
            })}
            rowKey="_id"
            columns={columns.filter(r =>
              ["logo", "client"].includes(r.dataIndex)
            )}
            dataSource={dataTable}
            pagination={{
              current: activePage,
              pageSize: limit,
              total: count,
              onChange: this.onChangePage
            }}
          />
        )}
        <CloseWindowModal showCloseWindowModal={showCloseWindowModal} />
        <PendingPaymentModal
          title={paymentMessage}
          showPendingPaymentModal={showPendingPaymentModal}
          handleHidePendingPaymentModal={this.handleHidePendingPaymentModal}
          closable={pendingPaymentModalClosable}
          paymentUrl={paymentUrl}
          closeLabel={closeLabel}
          rol={user.clientRole}
        />
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    width: state.app.width,
    user: state.authUser.user,
    data: state.clients.data,
    headers: state.clients.headers,
    isFetching: state.clients.isFetching,
    isDone: state.client.isDone,
    clienteSelected: state.client.data,
    error: state.clients.error
  };
};

const mapDispatchToProps = {
  getClients,
  getWorkClients,
  getClientById,
  getFilterUsers,
  getBreadCrumbsByClient,
  getUserClientRole,
  setPidExistsConfirmAssets,
  existsConfirmAssets,
  getNotifications,
  forceColor,
  setPid,
  getDefaultPermissions,
  cleanClientData,
  logout
};

export default injectIntl(
  withRouter(connect(mapStateToProps, mapDispatchToProps)(Clients))
);
